module.exports = __webpack_public_path__ + "static/BirdsEye-53bcb2ae3985d517dd2ca1b5d5c5705a.webm";